import { useMemo } from 'react';
import { initWidget, useDashboardStore } from './dashboard';
import { getSupportedWidgets } from '../config/utils';

export const useWidgetControl = () => {
  const widgets = useDashboardStore((state: any) => state.widgets);

  const availableWidgets = useMemo(() => {
    const widgetTypeMap = {};

    Object.values(widgets).forEach((w: any) => {
      widgetTypeMap[w.type] = widgetTypeMap[w.type] || [];
      widgetTypeMap[w.type].push(w);
    });

    const supportedWidgetList = getSupportedWidgets();
    const availableWidgets = supportedWidgetList.filter((widget) => {
      const widgetCount = widget.type in widgetTypeMap ? widgetTypeMap[widget.type].length : 0;
      return widget.meta.limit > widgetCount;
    });
    return availableWidgets;
  }, [widgets]);

  const addWidgets = (widgets: Record<string, number>) => {
    for (const [type, count] of Object.entries(widgets)) {
      const widgetData = availableWidgets.find((ele) => ele.type === type);
      for (let i = 0; i < Number(count); i++) {
        initWidget({ type: widgetData.type, state: widgetData.state });
      }
    }
  };

  return { availableWidgets, addWidgets };
};
